import { useEffect, useState } from "react";


export const ListaDeTareas = () => {


    useEffect(() => {

    }, []);//setProductos


    return (

        process.env.REACT_APP_URL_TEST === "true" &&
        <div className='text-black dark:text-white bg-[#000]  text-wrap break-all '>
            ORDEN DE PRIORIDAD:
            <ul className='!list-decimal pl-9'>
                <li>FIXIAR VULNERABILIDADES</li>
                <li>404 tema claro</li>
                <li>precio en usd no se carga cuando refrescas mucho la pagina.</li>
                <li>guardar en local el cronjobs</li>
                <li>ingroso de visitas en portafolio, haciendo publicidad. el record en 1 dia. lo que ofreces, son ese numero de visitas.</li>
                <li>si esta caido el server de cripto ya, que el dolar este en el maximo de la banda. 1500 ars x 1 usd</li>
                <li className="">
                    https://youtube.com/shorts/6y53lkPlsgw?feature=share
                    fotos y videos para movil o para monitores imagens segun tañaño dispositivo. detecta el disposito von el que entra.
                </li>
                <li>/diseño-web-palermo, agregale los 3 planes y lo que incluye cada plan (servicios) . tambien textos del slider.</li>
                <li>links con circulos en google. texto enriquesido?</li>
                <li>
                    sacar negrita en textos

                </li>

                <li>
                    tildes en verde semaforo
                </li>

                <li>
                    portafolio, dino, biciletas electricas
                </li>


                <li>
                    SEO<br />
                    palabra clave: diseño web palermo (en google)<br />
                    google light hause, semrush
                </li>

                <li>
                    Para conseguir enlaces desde sitios locales que apunten a tu landing de Palermo y mejoren tu SEO, lo clave es combinar **presencia estratégica** con **relaciones digitales**. Acá te dejo un plan concreto, adaptado a tu estilo y a Buenos Aires:

                    ---

                    ### 🧭 1. **Directorios locales y profesionales**
                    Registrate en sitios que listan servicios por zona. Algunos permiten agregar tu web con descripción:

                    - [Guía Clarín](https://guia.clarin.com/)
                    - [Cylex Argentina](https://www.cylex.com.ar/)
                    - [Paginas Amarillas](https://www.paginasamarillas.com.ar/)
                    - [Guía Local Palermo](https://palermo.guialocal.com.ar/) (si sigue activa)
                    - [Hotfrog Argentina](https://www.hotfrog.com.ar/)

                    💡 Tip: Usá el título “Diseñador Web en Palermo” o “Agencia Web Power Bit” en la descripción.

                    ---

                    ### 📝 2. **Blogs y medios barriales**
                    Contactá medios digitales de Palermo o Buenos Aires que publiquen notas sobre emprendimientos, tecnología o diseño. Ejemplos:

                    - Palermo Online
                    - Revista Bacanal
                    - Blogs de coworkings o espacios creativos (como AreaTres, La Maquinita)

                    Ofreceles una nota sobre “Cómo potenciar tu negocio con diseño web desde Palermo” y dejá tu enlace en la bio o al final.

                    ---

                    ### 📱 3. **Redes sociales con geolocalización**
                    - Publicá en grupos de Facebook como “Emprendedores Palermo”, “Diseño y Publicidad Buenos Aires”, etc.
                    - Usá hashtags como `#DiseñoWebPalermo`, `#AgenciaDigitalPalermo`, `#PowerBitBA`.
                    - En Instagram, etiquetá la ubicación “Palermo, Buenos Aires” en tus posts.

                    ---

                    ### 🤝 4. **Colaboraciones con negocios locales**
                    - Ofrecé diseño web a negocios de Palermo a cambio de que te mencionen en su sitio o redes.
                    - Ejemplo: “Sitio desarrollado por Power Bit” con enlace a tu landing.

                    ---

                    ### 🔗 5. **Foros y comunidades**
                    Participá en espacios como:
                    - [Taringa!](https://www.taringa.net/) (si sigue activo)
                    - Reddit Argentina (`r/argentina`)
                    - Grupos de LinkedIn sobre diseño y marketing en Buenos Aires

                    Compartí contenido útil y dejá tu enlace cuando sea relevante.

                    ---

                    Si querés, puedo ayudarte a redactar un mensaje de presentación para medios o negocios locales, con tono profesional y atractivo. También podemos armar una mini campaña de difusión para Palermo. ¿Te gustaría?

                </li>
                <li>
                    - Usá imágenes con alt="Diseño web en Palermo" o similares.
                    - Asegurate de que el texto esté en HTML real, no solo renderizado por JavaScript.
                    - Si tenés testimonios o logos de clientes locales, sumalos.
                    - Enlazá esta landing desde tu home y redes sociales con texto como “Agencia web en Palermo”.


                </li>
                <li>
                    "desarrolado por powerbit" en todos tus clientes
                </li>

                <li>

                    - Registrate en Google Business Profile con dirección en Palermo.

                </li>

                <li>next. optimizado para SEO. powerbit v3</li>
                <li>
                    bajar 25% los precios, apuntas a cloud server de powerbit. 380.000 el super.
                </li>

                <li>
                    Entiendo lo que estás buscando, Marcos: **cumplir con lo que Google exige como “cartel visible”** para verificar tu negocio, pero sin gastar de más. Aunque no lo dicen con lujo de detalles, lo que Google quiere ver es **una señal física que demuestre que Power Bit opera realmente en esa dirección**. Y sí, se puede lograr con muy poco presupuesto si lo hacés bien.

                    ---

                    ### ✅ ¿Qué tipo de cartel acepta Google?

                    Google no exige un cartel caro ni luminoso, pero sí que cumpla con estas condiciones:

                    | Requisito | ¿Por qué importa? | Cómo cumplirlo barato |
                    |-----------|-------------------|------------------------|
                    | 📛 Nombre comercial exacto | Debe coincidir con el nombre en Google Business | “Power Bit” en tipografía clara |
                    | 📍 Ubicación visible | Debe estar en el lugar donde atendés (aunque sea oficina privada) | Pegado en la puerta, vidrio o pared interna |
                    | 📸 Claridad en el video | Debe verse bien en la grabación | Buen contraste, luz natural, sin reflejos |
                    | 🧱 Fijo o semi-permanente | No puede parecer improvisado | Cartón rígido, vinilo, acrílico, o marco simple |

                    ---

                    ### 💸 Opciones económicas que funcionan

                    #### 1. **Cartel impreso en cartón pluma o PVC**
                    - Tamaño A3 o A4
                    - Impreso en gráfica local (menos de $3000 ARS)
                    - Pegado o apoyado en la pared detrás de tu escritorio

                    #### 2. **Vinilo adhesivo en la puerta o vidrio**
                    - Más profesional, pero sigue siendo económico
                    - Se puede imprimir por menos de $4000 ARS
                    - Se ve desde el pasillo si tenés puerta con vidrio

                    #### 3. **Marco con hoja impresa**
                    - Imprimís en hoja A4 con buena tipografía
                    - Lo ponés en un portarretrato o marco simple
                    - Se ve más serio que una hoja suelta

                    ---

                    ### 🎥 En el video, mostrá:

                    1. Entrada al edificio (número visible)
                    2. Subida al 5to piso (pasillo, puerta)
                    3. Cartel dentro de la oficina
                    4. Espacio de trabajo (computadora, escritorio)
                    5. Tu rostro y documento si lo pide

                    ---

                    ### 🧠 Tip extra

                    - Evitá hojas sueltas o manuscritas.
                    - No uses papel pegado con cinta sin soporte.
                    - Si tenés logo, incluilo. Si no, solo el nombre en tipografía clara.

                    ---

                    ¿Querés que te diseñe un cartel simple con el nombre y estilo de Power Bit listo para imprimir? También puedo ayudarte a redactar el guion del video para que lo grabes sin errores y te lo aprueben rápido.

                </li>

                <li>
                    /productos/a-medida   /productos/presencia /productos/super<br />
                    con mas decripcion del prodcuto


                </li>

                <li> microdata <br />
                    {

                        /*
                        
                                 <article itemscope itemtype="https://schema.org/Product">
                                                <h2 itemprop="name">Tienda Virtual Power Bit</h2>
                                                <img src="/imagenes/inicio.png" alt="Diseño de tienda virtual Power Bit" itemprop="image" />
                                                <p itemprop="description">Diseño de tienda virtual personalizada para negocios. Incluye catálogo, carrito de compras y conexión con redes sociales.</p>
                                                <span itemprop="offers" itemscope itemtype="https://schema.org/Offer">
                                                    <meta itemprop="priceCurrency" content="ARS" />
                                                    <meta itemprop="availability" content="https://schema.org/InStock" />
                                                    <span itemprop="price">Consultar</span>
                                                </span>
                                            </article>
                        
                        
                        */

                    }

                </li>

            </ul>


        </div>


    )
}

